<template>
  <div class="login_box">
   
    <div class="box1">
      <div class="box_logo">
        <img src="https://admin.bioflin.com/img/logo.e3083bd2.png" alt />
      </div>
      <div class="box_title">宝枫林店铺管理系统</div>
      <div class="box_ipt">
        <el-alert v-if="error!=null" :title="error" type="error" effect="dark"></el-alert>
        <el-input
          placeholder="请输入用户昵称"
          v-model="username"
          style="width:300px;margin: 10px auto 20px auto;"
          ref="ipt"
        >
          <i slot="prefix" class="el-input__icon el-icon-user-solid" style="font-size:24px"></i>
        </el-input>

        <el-input
          placeholder="请输入登陆密码"
          type="password"
          show-password
          style="width:300px;background:#fff;color:#fff"
          v-model="password"
        >
          <i slot="prefix" style="font-size:24px" class="el-input__icon el-icon-lock"></i>
        </el-input>
        <el-button
         
          @click="login"
          :loading="btnLoding"
          style="margin:  20px auto 20px auto;width:100%;background:#0099ff;color:#fff"
        >登陆</el-button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      btnLoding: false,
      error: null,
      password: "",
      username: ""
    };
  },
  created() {
    var _self = this;
    document.onkeydown = function() {
      var key = window.event.keyCode;
      if (key == 13) {
        _self.login();
      }
    };
  },
  activated() {},
  mounted() {
    this.$refs.ipt.focus();
  },
  methods: {
    login() {
      this.btnLoding = true;
      let config = {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        }
      };
      const Qs = require("qs");
      let obj = {
        username: this.username,
        password: this.password
      };

      const data = Qs.stringify(obj);

      this.axios
        .post(this.$store.state.serve + "shop/login", data, config)
        .then(res => {
          this.btnLoding = false;
          if (res.data.status === "success") {
            this.$cookies.set("shop_token", res.data.data.token);
            this.$cookies.set("shop_username", res.data.data.username);
            this.$message({
              type: "success",
              message: "登陆成功",
              offset: 60
            });
            this.$router.push("/index");
          } else if (res.data.status === "error") {
            this.error = res.data.msg;
          }
        });
    }
  }
};
</script>
<style lang='scss'>
.login_box {
  // background-image: url("http://localhost:8080/img/adminLogin.bdef87ee.jpg");
  // background-size: cover;
  // position: fixed;
  // left: 0;
  // top: 0;
  // right: 0;
  // bottom: 0;
  background-color: #f5f5f5;
  position: absolute;
  width: 100%;
  height: 100%;
  background-image: url("https://admin.bioflin.com/img/adminLogin.bdef87ee.jpg");
  background-repeat: no-repeat;
  background-position-y: 50%;
  .box1 {
    width: 350px;
    height: 420px;
    //background: rgba(3, 73, 119, 0.7);
    background: rgba(255, 255, 255, 1);
    border-top: 6px solid #0099ff;
    // box-shadow: 0px 1px 6px 0px rgba(3, 73, 119, 0.7);
    
    position: fixed;
    left: 50%;
    top: 50%;
    margin-top: -210px;
    margin-left: -175px;
    .box_logo {
      width: 84px;
      height: 84px;
      margin: 28px auto 21px auto;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .box_title {
      opacity: 1 inherit;
      text-align: center;
      font-size: 30px;
      font-family: "Microsoft YaHei";
      font-weight: bold;
      color: #0099ff;
    }
    .box_ipt {
      width: 300px;
      margin: 0 auto;
    }
  }
}
</style>